import React, { Suspense } from "react";
import { Container } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import BrandHeaderAtom from "../components/atoms/brand-header/brand-header";
import RouteProgressBar from "../components/atoms/route-progress-bar/RouteProgressBar";
import "./layouts.scss";

const LayoutLoading = () => <div className="layout-loading">Loading protected content...</div>;

const ProtectedLayout = () => {
    const { isAuthenticated } = useSelector((state) => state.auth) || {};

    if (!isAuthenticated) {
        return <Navigate to="/login" />;
    }

    return (
        <div className="app-container">
            <RouteProgressBar />
            <BrandHeaderAtom />
            <Container fluid className="content-container">
                <Suspense fallback={<LayoutLoading />}>
                    <Outlet />
                </Suspense>
            </Container>
        </div>
    );
};

export default ProtectedLayout;
